import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// Maximum time in milliseconds defining how long the user's offline state should be hidden from them.
const TRANSPARENT_OFFLINE_TIMEOUT = 5000;

export default class OfflineAlert extends PureComponent {
  static propTypes = {
    closeOfflineAlert: PropTypes.func.isRequired,
    handleOffline: PropTypes.func.isRequired,
    handleOnline: PropTypes.func.isRequired,
    isOffline: PropTypes.bool.isRequired,
    isOfflineAlertOpen: PropTypes.bool,
    openOfflineAlert: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { handleOffline, handleOnline } = this.props;

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
  }

  componentDidUpdate(prevProps) {
    const { isOffline } = this.props;

    if (isOffline && !prevProps.isOffline) {
      this.onOffline();
    } else if (!isOffline && prevProps.isOffline) {
      this.onOnline();
    }
  }

  componentWillUnmount() {
    const { handleOffline, handleOnline } = this.props;

    window.removeEventListener('offline', handleOffline);
    window.removeEventListener('online', handleOnline);

    clearTimeout(this.timeout);
  }

  onOffline = () => {
    this.timeout = setTimeout(this.props.openOfflineAlert, TRANSPARENT_OFFLINE_TIMEOUT);
  }

  onOnline = () => {
    clearTimeout(this.timeout);

    this.props.closeOfflineAlert();
  }

  render() {
    const { isOfflineAlertOpen } = this.props;

    if (!isOfflineAlertOpen) {
      return null;
    }

    return (
      <div className="browserWarnings stickToTop browserWarnings--disabledJs">
        <section className="browserWarnings__container">
          <div className="browserWarnings__content">
            <h2 className="browserWarnings__heading">Oh dear, you’re offline.</h2>
            <p>
              You can continue to shop from this page, but some features may not work.{' '}
              We’ll sync any changes with our website once you’re back online.
            </p>
          </div>
        </section>
      </div>
    );
  }
}
